import type { CrmListsQueryFactory } from "./types";

export const CRM_LISTS_QUERY_KEY = "crm:lists";

export const crmListsQueryKeys: CrmListsQueryFactory = {
    all(): readonly string[] {
        return [CRM_LISTS_QUERY_KEY];
    },
    list(page: number): readonly string[] {
        return [CRM_LISTS_QUERY_KEY, page.toString()];
    },
};
